/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from 'src/components/common/cpds/utils/cpds-utils';
import { Video } from 'src/components/common/modules/video-player/video';
import { Typo } from 'components/common/ui';
import { checkValue } from 'components/functions';
import { BackgroundVariant } from 'components/common/modules/v3/brand/v3-breaker-video-module/components/v3-breaker-video-module';

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

// Your Styles goes here and use token ex: ${token?.button_primary_background_color}

*/

const getTextColor = (token, backgroundVariant, isExpand) => {
  const defaultColor = isExpand ? '#31374F' : '#0C0E1C';

  if (!backgroundVariant) return defaultColor;

  switch (backgroundVariant.toLowerCase()) {
    case BackgroundVariant.PRIMARY:
      return isExpand
        ? token?.module_v3_breaker_video_primary_text_active_color || defaultColor
        : token?.module_v3_breaker_video_primary_text_color || defaultColor;
    case BackgroundVariant.SECONDARY:
      return isExpand
        ? token?.module_v3_breaker_video_secondary_text_active_color || defaultColor
        : token?.module_v3_breaker_video_secondary_text_color || defaultColor;
    case BackgroundVariant.TERTIARY:
      return isExpand
        ? token?.module_v3_breaker_video_tertiary_text_active_color || defaultColor
        : token?.module_v3_breaker_video_tertiary_text_color || defaultColor;
    default:
      return defaultColor;
  }
};

const VideoContainer = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    // const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      position: relative;
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const Player = styled(Video)`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      width: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: ${token?.module_v3_video_breaker_video_border_radius || '0'};
      aspect-ratio: 16/ 9;
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const AccordionHeading = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    backgroundVariant,
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const textColor = getTextColor(token, backgroundVariant, props?.isExpand);

    return css`
      margin-right: 8px;
      font-weight: 400 !important;
      color: ${textColor};

      & ~ .cpds-icon path {
        fill: ${textColor};
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const AccordionBody = styled.div`
  ${() => {
    return css`
      display: flex;
      align-items: start;
      gap: 16px;
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const Transcript = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    backgroundVariant,
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      font-style: italic !important;
      font-weight: 400 !important;
      color: ${checkValue(backgroundVariant)
        ? backgroundVariant.toLowerCase() === BackgroundVariant.PRIMARY
          ? token?.module_v3_breaker_video_primary_transcript_color || '#676A7D'
          : backgroundVariant.toLowerCase() === BackgroundVariant.SECONDARY
          ? token?.module_v3_breaker_video_secondary_transcript_color || '#676A7D'
          : backgroundVariant.toLowerCase() === BackgroundVariant.TERTIARY
          ? token?.module_v3_breaker_video_tertiary_transcript_color || '#676A7D'
          : '#676A7D'
        : '#676A7D'};

      @keyframes karaoke {
        0% {
          opacity: 0.5;
        }
        100% {
          opacity: 1;
        }
      }
      span {
        &.highlight {
          color: ${checkValue(backgroundVariant)
            ? backgroundVariant.toLowerCase() === BackgroundVariant.PRIMARY
              ? token?.module_v3_breaker_video_primary_text_active_color || '#31374F'
              : backgroundVariant.toLowerCase() === BackgroundVariant.SECONDARY
              ? token?.module_v3_breaker_video_secondary_text_active_color || '#31374F'
              : backgroundVariant.toLowerCase() === BackgroundVariant.TERTIARY
              ? token?.module_v3_breaker_video_tertiary_text_active_color || '#31374F'
              : '#31374F'
            : '#31374F'};
          font-weight: bold;
          &.animate {
            animation: karaoke 1s forwards;
          }
        }
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const Timestamp = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    backgroundVariant,
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      color: ${checkValue(backgroundVariant)
        ? backgroundVariant.toLowerCase() === BackgroundVariant.PRIMARY
          ? token?.module_v3_breaker_video_primary_text_active_color || '#31374F'
          : backgroundVariant.toLowerCase() === BackgroundVariant.SECONDARY
          ? token?.module_v3_breaker_video_secondary_text_active_color || '#31374F'
          : backgroundVariant.toLowerCase() === BackgroundVariant.TERTIARY
          ? token?.module_v3_breaker_video_tertiary_text_active_color || '#31374F'
          : '#31374F'
        : '#31374F'};

      min-width: 54px;
      font-weight: 400 !important;
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export { Player, VideoContainer, Transcript, Timestamp, AccordionHeading, AccordionBody };
